export { default } from './SEOItem';
